const templateUrl = require('./expiration-warning.html');

const app = angular.module('msi.payments.expirationWarning', [
  require('./expiration-warning.controller')
]);

app.component('ogPaymentExpirationWarning', {
  templateUrl: templateUrl,
  bindings: {
    shipment: '<ogFor'
  },
  controller: 'expirationWarningController'
});

module.exports = app.name;
